/* globals Knitiv */

export default class IconController {
	/* @ngInject */
	/**
	 * @param {any} $copyToClipboard
	 * @param {import('angular').IFilterService} $filter
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 * @param {any} Help
	 */
	constructor(
		$copyToClipboard,
		$filter,
		$rootScope,
		$translate,
		$uibModal,
		Help,
	) {
		this.$copyToClipboard = $copyToClipboard;
		this.$filter = $filter;
		this.$rootScope = $rootScope;
		this.$translate = $translate;
		this.Help = Help;

		/** @type {boolean} */
		this.adminDebug = false;

		/** @type {string} */
		this.id = '';

		/** @type {any} */
		this.openModal = $uibModal.open;

		/** @type {'modal' | 'popover' | 'tooltip'} */
		this.type = 'tooltip';
	}

	$onInit() {
		if (this.$rootScope?.context?.profil?.admin) {
			this.adminDebug = true;
		}

		if (!this.class) {
			this.class = 'text-muted';
		}

		return;

		// eslint-disable-next-line no-unreachable
		(async () => {
			const helps = await this.Help.request(this.id);
			if (helps && this.id in helps) {
				this.adminDebug = false;
				if ('tooltip' in helps[this.id]) {
					this.type = 'tooltip';
					this.help = helps[this.id].tooltip;
				}
				else if ('popover' in helps[this.id]) {
					this.type = 'popover';
					this.help = helps[this.id].popover;
				}
				else if ('modal' in helps[this.id]) {
					this.type = 'modal';
					this.help = helps[this.id].modal;
				}
			}
		})();
	}

	copyToClipboard() {
		if (this.$rootScope.context?.profil.admin) {
			this.$copyToClipboard(
				this.id,
				true,
				(/** @type {string} */ v) => this.$filter('sprintf')(
					this.$translate.instant('common.x-copied-to-clipboard'),
					v,
				),
			);
		}
	}
}
